export type brandsDataItem = {
  id: string | number
  src: string
}

export const data: brandsDataItem[] = [
  {
    id: 1,
    src: '/assets/brands/brand-1.png',
  },
  {
    id: 3,
    src: '/assets/brands/brand-2.png',
  },
  {
    id: 4,
    src: '/assets/brands/brand-3.png',
  },
  {
    id: 5,
    src: '/assets/brands/brand-4.png',
  },
  {
    id: 6,
    src: '/assets/brands/brand-5.png',
  },
  {
    id: 7,
    src: '/assets/brands/brand-6.png',
  },
  {
    id: 8,
    src: '/assets/brands/brand-7.png',
  },
  {
    id: 9,
    src: '/assets/brands/brand-1.png',
  },
  {
    id: 10,
    src: '/assets/brands/brand-2.png',
  },
  {
    id: 11,
    src: '/assets/brands/brand-3.png',
  },
  {
    id: 12,
    src: '/assets/brands/brand-4.png',
  },
  {
    id: 13,
    src: '/assets/brands/brand-5.png',
  },
]
